import { render, staticRenderFns } from "./HeaderModals.vue?vue&type=template&id=55faf988&lang=pug&"
import script from "./HeaderModals.vue?vue&type=script&lang=ts&"
export * from "./HeaderModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports